import axios from 'axios';
import { LoginResponse, SignupData, League } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  loginPlayer: (emailOrId: string, password: string): Promise<LoginResponse> =>
    api.post('/auth/login/player', { emailOrId, password }).then(res => res.data),
  
  loginAdmin: (email: string, password: string): Promise<LoginResponse> =>
    api.post('/auth/login/admin', { email, password }).then(res => res.data),

  loginBookie: (email: string, password: string): Promise<LoginResponse> =>
    api.post('/auth/login/bookie', { email, password }).then(res => res.data),
  
  signupPlayer: (userData: SignupData): Promise<LoginResponse> =>
    api.post('/auth/signup/player', userData).then(res => res.data),
  
  signupAdmin: (userData: SignupData): Promise<LoginResponse> =>
    api.post('/auth/signup/admin', userData).then(res => res.data),

  signupBookie: (userData: SignupData): Promise<LoginResponse> =>
    api.post('/auth/signup/bookie', userData).then(res => res.data),
  
  verifyToken: () =>
    api.get('/auth/verify').then(res => res.data),
};

// League API
export const leagueAPI = {
  getLeagues: (): Promise<League[]> =>
    api.get('/leagues').then(res => res.data),
  
  getLeague: (id: number): Promise<League> =>
    api.get(`/leagues/${id}`).then(res => res.data),
};

export default api;
